import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Section, SectionAddPayload, SectionsUpdatePayload } from './sections.interface';
import { Observable, map } from 'rxjs';
@Injectable({
  providedIn: 'root',
})
export class SectionsService {
  private basePath = environment.interop.basePath;
  private getSectionList =
    this.basePath +
    environment.interop.urbanism.nomenclatoare.section.getSections;
  private getSectionDT =
    this.basePath +
    environment.interop.urbanism.nomenclatoare.section.getSectionsDT;
  private token!: string;
  private httpOptions: any;
  private storeSectionURL =
    this.basePath +
    environment.interop.urbanism.nomenclatoare.section.storeSection;
  private updateStoreSection =
    this.basePath +
    environment.interop.urbanism.nomenclatoare.section.putSection;
  private deleteStoreSection =
    this.basePath +
    environment.interop.urbanism.nomenclatoare.section.deleteSection;
  private getSectionsActive =
    this.basePath +
    environment.interop.urbanism.nomenclatoare.section.getSectionsActive;
  private getSectionsPublic =
    this.basePath +
    environment.interop.urbanism.nomenclatoare.section.getSectionsActivePublic;

  constructor(private http: HttpClient) {}


  getSectionsList(): Observable<Section[]> {
    return this.http.get(this.getSectionList, this.httpOptions).pipe(map((response:any) => response.data));
  }

  getSectionsDT() {
    return this.http.get(this.getSectionDT, this.httpOptions);
  }
  
  addSection(section: SectionAddPayload) {
    return this.http.post(this.storeSectionURL, section, this.httpOptions);
  }

  updateSection(section: SectionsUpdatePayload) {
    return this.http.put(this.updateStoreSection, section, this.httpOptions);
  }

  deleteSection(sectionId: number) {
    return this.http.delete(this.deleteStoreSection + sectionId);
  }

  getActiveSections() {
    return this.http.get(this.getSectionsActive, this.httpOptions);
  }

  getPublicSections() {
    return this.http.get(this.getSectionsPublic, this.httpOptions);
  }

  setToken(token: string) {
    this.token = token;
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${this.token}`,
      }),
    };
  }
}
